// specific to SA
import Component from '../../UM-Base/components/Component';
import { TripPlannerMode } from '../../UM-Base/lib/TripPlannerHelper';
import { getConfig, UserManager } from '../../UM-Base/lib/OidcHelper';

let thisComponent = null;  // a less painful way to pass js class "this" around.

export default class OidcSignin extends Component {

  load() {
    console.log('OidcSignin.');

    const now = new Date().getTime();  // returns time in milliseconds
    sessionStorage.setItem('signinPageVisited', now);  // returns time in milliseconds);
    // console.log('signinPageVisited', sessionStorage.getItem('signinPageVisited'));

    thisComponent = this;

    const config = getConfig(window.location);
    this.oidcUserManager = new UserManager(config);


    const mgr = new UserManager({
      response_mode: 'query'
    });


    mgr.signinRedirectCallback().then(function () {
      // Add this to deal with other tabs and logouts
      localStorage.setItem('LOGGED_IN', true);
      localStorage.setItem('tpMode', TripPlannerMode.login);

      // If using optimizely ODP, then send email event and then redirect, else just redirect.
      if (window.zaius) {
        thisComponent.addOptimizelyOdpLoginEvent();
      } else {

        thisComponent.redirectToOrigPage();
      }
    }).catch(function (error) {
      // console.error(error);
      // if login was cancelled don't try to reopen modals
      sessionStorage.removeItem('modalOpen_Plan');
      sessionStorage.removeItem('modalOpen_Add');
      localStorage.removeItem('LOGGED_IN');
      // redirect to previous page, or home page
      // warn just the error.message and not the whole error object
      console.warn('error (could be a cancelled login): ', error.message);
      thisComponent.redirectToOrigPage();
    });

    mgr.clearStaleState();

    // TODO: Create new route in Umbraco and only run this code for silent callback
    // var mgr = new Oidc.UserManager();
    // mgr.signinSilentCallback();

    // new UserManager({
    //   response_mode: 'query'
    // }).signoutPopupCallback();

    super.load();
  }

  redirectToOrigPage() {
    const redirectPage = sessionStorage.getItem('redirectPage');
    // if redirectPage truthy redirect, else go to origin.
    window.location = (!!redirectPage) ? redirectPage + '' : location.origin;
  }

  addOptimizelyOdpLoginEvent() {
    localStorage.setItem('addOptimizelyOdpLoginEvent', true);

    // Send login event
    window.zaius.event("User", {
      action: "login",
    });

    // Add email and name details. Subscribe if they have opted in.
    thisComponent.sendOdpCustomerEvent();
  }

  async sendOdpCustomerEvent() {

    // zaius.anonymize(); // Useful in console to create a new user
    const user = await this.oidcUserManager.getUser();
    const email = user?.profile.email;

    // Has user been identified before?
    const hasLoggedin = localStorage.getItem('odpU');

    if (typeof email === 'string' && email.length > 5 && email.includes('@') && email.includes('.')) {

      // Set flag to say user has been identified
      localStorage.setItem('odpU', '1');

      // user.middle_name === 'Y' means user has opted in to receive emails
      if (user.middle_name === 'Y' && !hasLoggedin) {

        const subListId = document.querySelector('meta[name="opt.sub.list.id"]');
        if (!subListId) return;

        window.zaius.subscribe({
          list_id: subListId, // Note: to subscribe to multiple list, you can put array of list ids e.g. ["newsletter_subscribe","see_south_australia"]
          email: email,
          first_name: user.given_name,
          last_name: user.family_name,
        });

        this.sendHashEmailToODP(email);
      } else {
        const hashEmail = await this.getHashEmailToODP();
        window.zaius.customer({
          email: email,
          first_name: user.given_name,
          last_name: user.family_name,
          ...hashEmail
        },
        {
          ...this.getPRID()
        }
      );

        //this.sendHashEmailToODP(email);
      }
    }

    this.redirectToOrigPage();
  }

  sendHashEmailToODP(email) {
    (async () => {
      try {
        const hashEmail = await this.getHashEmailToODP();

        window.zaius.customer({
          ...this.hashEmail(),
          email: `${email}`
        },
        {
          ...this.getPRID()
        }
      );
        
        localStorage.setItem('sendHashEmailToODP', `success ${hashEmail}-hcSatcData:${this.getPRID()}`);
      } catch (e) {
        localStorage.setItem('sendHashEmailToODP', "failed" + e.message);
      }
    })();
  }
  
    async getHashEmailToODP(email) {
      try {
        const hashEmail = await this.hash(email);
                
        // Store result in localStorage for debugging or logging
        localStorage.setItem('getHashEmailToODP', `success ${hashEmail} - hcSatcData: ${JSON.stringify(hcSatcData)}`);
    
        // Return the hash object as requested
        return { sha256_email_hash: hashEmail };
      } catch (e) {
        localStorage.setItem('getHashEmailToODP', "failed " + e.message);
        console.error("Error in getHashEmailToODP:", e);
        return null; // Return null or handle the error as needed
      }
    }

  getPRID() {
    const profileValues = buildAfxProfileValues();
        
    if (profileValues?.prid) {
      const hcSatcId = profileValues.prid;
      
      // Store hc_satc_id in localStorage
      localStorage.setItem("hc_satc_id", hcSatcId);
      return { "hc_satc_id": hcSatcId }; // Return as an object
    } else {        
      console.log("prid is not available.");
      return null; // Return null if prid is not available
    }
  }

  buildAfxProfileValues() {
    // Get the `afx_profile` cookie value
    const cookieValue = document.cookie
      .split('; ')
      .find(row => row.startsWith('afx_profile='))
      ?.split('=')[1];
    
    if (!cookieValue) {
      return { acid: null, prid: null };
    }
    // Decode the cookie JSON string and parse it
    const afxProfile = JSON.parse(decodeURIComponent(cookieValue));
    // Extract the acid and prid values
    const acid = afxProfile.acid || null;
    const prid = afxProfile.prid || null;
    return { acid, prid };
  }


  async getUserEmail() {
    const user = await this.oidcUserManager.getUser();

    return new Promise((resolve, reject) => {
      let count = 0;

      const interval = setInterval(() => {
        if (user) {
          clearInterval(interval);
          resolve(user.profile.email);
        }

        count++;
        if (count > 20) {
          clearInterval(interval);
          reject('');
        }
      }, 200);
    });
  }

  hash(string) {
    const utf8 = new TextEncoder().encode(string);
    return crypto.subtle.digest('SHA-256', utf8).then((hashBuffer) => {
      const hashArray = Array.from(new Uint8Array(hashBuffer));
      const hashHex = hashArray
        .map((bytes) => bytes.toString(16).padStart(2, '0'))
        .join('');
      return hashHex;
    });
  }
}